export default function TrustBar() {
  return (
    <>
      <section className="trust-bar">
        <div className="container trust-inner">
          <div className="trust-item">✅ Verified ID drivers</div>
          <div className="trust-item">💰 Fixed, no-surge fares</div>
          <div className="trust-item">📍 Live trip tracking</div>
          <div className="trust-item">🎧 24×7 rider support</div>
          <div className="trust-item">🔄 Free cancellation</div>
        </div>
      </section>
    </>
  );
}
